import { useMediaQuery, useTheme } from '@mui/material'
import MediaDownload from './iconButtons/MediaDownload'
import MediaDetails from './iconButtons/MediaDetails'

// TODO (NEX-4111): Remove Print Shop button until it can be fixed, as it
// redirects to an Access Denied page currently
function MediaIconMenu() {
  return (
    <>
      <MediaDetails />
      <MediaDownload />
      {/* <MediaPrintShop /> */}
    </>
  )
}

export default function GalleryIconButtons() {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  if (isMobile) {
    return null
  }

  return <MediaIconMenu />
}
